
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23.303","height":"18.926","viewBox":"0 0 23.303 18.926"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 147413","d":"M20.908 4.717a10.266 10.266 0 002.4-2.469 9.575 9.575 0 01-2.75.739 4.763 4.763 0 002.1-2.632 9.4 9.4 0 01-3.031 1.153A4.765 4.765 0 0016.137 0a4.774 4.774 0 00-4.776 4.776 5.391 5.391 0 00.118 1.094 13.576 13.576 0 01-9.848-5A4.74 4.74 0 00.98 3.28a4.773 4.773 0 002.125 3.98 4.81 4.81 0 01-2.159-.606v.059a4.777 4.777 0 003.83 4.687 5.05 5.05 0 01-1.257.163 6.019 6.019 0 01-.9-.074 4.784 4.784 0 004.464 3.312 9.565 9.565 0 01-5.93 2.041A9.884 9.884 0 010 16.782a13.5 13.5 0 007.334 2.14A13.5 13.5 0 0020.923 5.338c0-.207 0-.416-.015-.621z","fill":"#245389"}})])
          )
        }
      }
    